'use client';
import React, { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';
import Link from 'next/link';

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'La Propiedad', href: '#galeria' },
    { label: 'Ventajas', href: '#ventajas' },
    { label: 'Amenidades', href: '#amenidades' },
    { label: 'Ubicación', href: '#ubicacion' },
    { label: 'Contacto', href: '#contacto' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-primary/95 backdrop-blur-md shadow-md py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AppLogo size={36} />
          <span className="font-display text-xl font-semibold text-primary-foreground tracking-tight">
            Bahía Baliz
          </span>
        </div>

        {/* Desktop nav */}
        <ul className="hidden lg:flex items-center gap-8">
          {navLinks?.map((link) => (
            <li key={`nav-${link?.label}`}>
              <a
                href={link?.href}
                className="text-sm font-medium text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                {link?.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            href="/login-screen"
            className="px-4 py-2 rounded-lg text-sm font-medium text-primary-foreground border border-primary-foreground/30 hover:bg-primary-foreground/10 transition-colors"
          >
            Acceso Socios
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="lg:hidden p-2 text-primary-foreground"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden bg-primary/98 backdrop-blur-md border-t border-primary-foreground/10 fade-in">
          <ul className="max-w-screen-2xl mx-auto px-6 py-4 flex flex-col gap-3">
            {navLinks?.map((link) => (
              <li key={`mobile-nav-${link?.label}`}>
                <a
                  href={link?.href}
                  className="block py-2 text-sm font-medium text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  {link?.label}
                </a>
              </li>
            ))}
            <li>
              <Link
                href="/login-screen"
                className="block py-2 text-sm font-medium text-accent hover:text-accent/80 transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                Acceso Socios →
              </Link>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}